import React from 'react';
import * as S from './ListingHeader.styles';

import BreadCrumb from '../../common/BreadCrumb/BreadCrumb';
import HeaderNav from './HeaderNav/HeaderNav';

const ListingHeader = ({headers, activeTab, updateActiveTab}) => {
    return(
      <S.ListingHeaderOuterWrap>
        <S.ListingHeaderTopBack>
          <S.ListingHeadBackColor status={activeTab}/>
        </S.ListingHeaderTopBack>
        <S.ListingHeaderInfoOuterWrap>
          <S.ListingHeaderInfoInnerWrap>
            <BreadCrumb />
            <HeaderNav headers={headers} activeTab={activeTab} updateActiveTab={updateActiveTab} />
          </S.ListingHeaderInfoInnerWrap>
        </S.ListingHeaderInfoOuterWrap>
      </S.ListingHeaderOuterWrap>
    );
}

export default ListingHeader; 